module.exports = __webpack_public_path__ + "assets/img/main-logo-shijiazhuang.85038f6a.png";